import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=01982cde&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=01982cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01982cde",
  null
  
)

export default component.exports